import type { LaunchState } from '@/lib/launchpad/types'

type Listener = (launch: LaunchState) => void

const listeners = new Set<Listener>()

function launchKeys(launch: LaunchState) {
  return [launch.id, launch.contractAddress, launch.tokenAddress]
    .filter((value): value is string => Boolean(value))
    .map(value => value.toLowerCase())
}

export function sameTradedLaunch(a: LaunchState, b: LaunchState) {
  const keys = new Set(launchKeys(a))
  return launchKeys(b).some(key => keys.has(key))
}

/**
 * Fired whenever a curve buy/sell/claim completes (sim or on-chain).
 *
 * Consumers (wallet holding poller, ETH balance poller, holders list) use
 * this to refresh immediately instead of waiting for their next timed poll
 * or the next time the page happens to be reopened, so balances and the
 * public holders list reflect real state right after every transaction.
 */
export function notifyLaunchTraded(launch: LaunchState) {
  listeners.forEach(listener => listener(launch))
}

export function subscribeLaunchTraded(listener: Listener) {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}
